import { Button, Col, Form, Row, Typography } from 'antd';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import { MemberCorpoPayload } from 'domain/entities/UserEntity';
import { openSuccessNoti } from 'presentation/components/Notification';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { FormTextArea } from 'presentation/components/form/FormTextArea.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

const INPUT_TEXT_MAX_LENGTH = 100;

interface StepProps {
    data?: MemberCorpoPayload;
    userUseCase: UserUseCaseInterface;
    mode: 'create' | 'edit';
}

export const ConfirmForm = ({ data, userUseCase, mode }: StepProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [form] = Form.useForm();

    useEffect(() => {
        onChangeForm();
    }, [data]);

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const submitNext = async () => {
        try {
            dispatch(startFetching());
            let response = null;
            if (mode === 'edit') {
                response = await userUseCase.editMemberCorproInfo(
                    data ?? ({} as MemberCorpoPayload),
                );
            } else {
                response = await userUseCase.registMemberCorproInfo(
                    data ?? ({} as MemberCorpoPayload),
                );
            }
            if (response) {
                openSuccessNoti({ description: getMessage('S0315') });
                navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_003_01);
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <>
            <Form
                form={form}
                className="w-full"
                onValuesChange={() => {
                    onChangeForm();
                }}
                onFinish={submitNext}
            >
                <Row className="min-w-min w-full">
                    {/* <Row className="pb-[12px]">
                        <Typography.Text className="text-base">
                            購入を希望される場合
                        </Typography.Text>
                    </Row> */}
                    {/* <Row className="pb-[32px]">
                        <FormCheckBox
                            name="agree1"
                            required
                            showErrorMessage={false}
                            options={[
                                {
                                    value: 1,
                                    label: '当アプリ上で物件を購入する場合は、株式会社シイ・アイ・シーに賃貸管理業務を委託します。',
                                },
                            ]}
                            className="mb-0"
                        />
                    </Row> */}
                    <Row>
                        <Col span={24}>
                            <FormTextArea
                                label="反社会勢力"
                                name="antiSocialForce"
                                disabled
                                placeholder={PLACEHOLDER.ANTISOCIAL_TEXT}
                                maxLength={INPUT_TEXT_MAX_LENGTH}
                                size={'large'}
                                className="custom-bg"
                                labelClassName="content-step-form label-step-form"
                                rows={10}
                            />
                        </Col>
                    </Row>
                    <Row className="pb-[12px]">
                        <Col span={24}>
                            <FormCheckBox
                                name="agree2"
                                required
                                showErrorMessage={false}
                                options={[
                                    {
                                        value: 1,
                                        label: '同意します。',
                                    },
                                ]}
                                className="mb-0"
                            />
                        </Col>
                    </Row>
                </Row>
                <Row justify="center" className="w-full mt-6">
                    <Col span={12}>
                        <Button
                            type="primary"
                            size="large"
                            disabled={btnDisable}
                            onClick={() => submitNext()}
                            className="button-container"
                        >
                            この内容で登録する
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    );
};
